// ----------------------------------------------------------------------

export { default as NavSectionVertical } from './vertical';
export { default as NavSectionHorizontal } from './horizontal';

export function isExternalLink(path) {
  return path?.includes('http');
}

/**
 * Item do menu esta ativo?
 *
 * DEFEITO CORRIGIDO: era `pathname.includes(path) || asPath.includes(path)`, ou
 * seja comparacao por SUBSTRING. Desde que as telas novas ganharam o sufixo
 * `-novo`, abrir `/dashboard/politicas-novo` marcava TAMBEM "Politicas" antiga
 * como ativa, porque `/dashboard/politicas` e substring de
 * `/dashboard/politicas-novo`. Dois itens acesos ao mesmo tempo, e o usuario sem
 * saber em qual esta.
 *
 * Agora a comparacao e por SEGMENTO: bate se for o caminho exato ou se o proximo
 * caractere for `/` (rota filha, ex.: `/dashboard/tickets/feriados` acende
 * "Tickets").
 */
export function getActive(path, pathname, asPath) {
  if (!path) return false;

  const casa = (atual) => {
    if (!atual) return false;
    if (atual === path) return true;
    return atual.startsWith(`${path}/`);
  };

  return casa(pathname) || casa(asPath);
}
